/**
 * Global Date Format Configuration
 *
 * This configuration ensures consistent European date format (DD/MM/YYYY) across the entire application.
 * To change to a different format, modify the values in this file.
 */

export const DATE_FORMAT_CONFIG = {
  // Angular locale (en-GB uses DD/MM/YYYY format)
  locale: 'en-GB',

  // Taiga UI date format
  tuiDateFormat: 'DMY',
  tuiDateSeparator: '/',

  // Custom date format strings for the date pipe
  formats: {
    short: 'dd/MM/yyyy, HH:mm', // 15/01/2025, 14:30
    medium: 'dd MMM yyyy, HH:mm:ss', // 15 Jan 2025, 14:30:45
    long: 'dd MMMM yyyy, HH:mm:ss', // 15 January 2025, 14:30:45
    shortDate: 'dd/MM/yyyy', // 15/01/2025
    mediumDate: 'dd MMM yyyy', // 15 Jan 2025
    longDate: 'dd MMMM yyyy', // 15 January 2025
    shortTime: 'HH:mm', // 14:30 (24-hour format)
    mediumTime: 'HH:mm:ss', // 14:30:45
    longTime: 'HH:mm:ss zzz', // 14:30:45 GMT
    custom: 'dd/MM/yyyy HH:mm', // Default custom format
  },

  // Default format when none is specified
  defaultFormat: 'short',

  // Time zone (optional, uses browser default if not specified)
  // timezone: 'Europe/Athens'
};

/**
 * Usage Instructions:
 *
 * 1. Date Pipe in Templates:
 *    {{ dateValue | date:'short' }}     // Uses European format automatically
 *    {{ dateValue | euroDate:'short' }}  // Uses custom pipe with guaranteed European format
 *
 * 2. Date Pipe in TypeScript:
 *    const datePipe = new DatePipe('en-GB');
 *    const formatted = datePipe.transform(date, 'dd/MM/yyyy');
 *
 * 3. Taiga UI Date Inputs:
 *    <tui-input-date> components will automatically use DD/MM/YYYY format
 *
 * 4. To change date format globally:
 *    - Update the 'locale' property (e.g., 'en-US' for MM/DD/YYYY)
 *    - Update the 'tuiDateFormat' property (e.g., 'MDY' for MM/DD/YYYY)
 *    - Update the format strings in the 'formats' object
 */
